module.exports = __webpack_public_path__ + "img/VL_06_01.6d019406.png";